import React from 'react';
import { FormHelperText, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { useListCountriesQuery } from '../../api/brokerGroupsApi';
import { BROKER_GROUP_FIELD_LABELS } from '../brokerGroupFormValues';

/**
 * The broker group's timezone: disabled until a country is chosen, then that country's
 * timezones. A stored timezone from another country stays shown (and can't be picked
 * again), in error, until it's changed.
 */
export const BrokerGroupTimezoneField = () => {
	const { values, touched, errors, setFieldValue } = useFormikContext();
	const { data: countries = {} } = useListCountriesQuery();
	const timezones = countries[values.country]?.timezones;
	const error = touched.timezone && errors.timezone;

	const options = [
		...(timezones ?? []),
		...(values.timezone && !timezones?.includes(values.timezone) ? [values.timezone] : []),
	];

	return (
		<Grid size={{ xs: 12, sm: 4 }}>
			<AdminFieldLabel name='timezone'>{BROKER_GROUP_FIELD_LABELS.timezone}</AdminFieldLabel>
			<ResponsiveAutocomplete
				options={options}
				value={values.timezone || null}
				onChange={(timezone) => setFieldValue('timezone', timezone ?? '')}
				isOptionDisabled={(option) => !timezones?.includes(option.id)}
				disabled={!timezones}
				error={Boolean(error)}
			/>
			{error && <FormHelperText error>{error}</FormHelperText>}
		</Grid>
	);
};
